// eslint-disable-next-line no-restricted-imports
import {
  DirectoryGetRecordsDocument,
  useDirectoryUpdateRecordMutation,
} from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { DirectoryRecordFieldParam } from 'api/types/params';

export interface DirectoryUpdateRecordParam {
  fields: DirectoryRecordFieldParam[];
}

export const useDirectoryUpdateRecord = () => {
  const [handleCreateRecord, { loading, error: apolloError }] =
    useDirectoryUpdateRecordMutation({
      awaitRefetchQueries: true,
      refetchQueries: [DirectoryGetRecordsDocument],
    });

  const error = useError(apolloError);

  const updateRecord = async (
    id: string,
    versionNumber: number,
    input: DirectoryUpdateRecordParam
  ) => {
    await handleCreateRecord({
      variables: {
        id,
        input: {
          versionNumber,
          fields: input.fields.map((field) => ({
            name: field.name,
            referenceRecordId: field.referenceRecordId,
            value: field.value,
          })),
        },
      },
    });
  };

  return { updateRecord, loading, error };
};
